module.exports = "/shifts/schedule-templates/modal-template-users-conflict-b3e2c4.html";